<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      width: '*',
      visible: true
    },
    {
      header: 'address' | translate,
      binding: 'address',
      width: '*',
      visible: true
    }
  ]"
  [filterable]="false"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [mode]="'DIALOG'"
  [service]="{
    service: service,
    name: 'shipping_address',
    form: 'SHIPPING_ADDRESS',
    showButton: false,
    showDropDownButton: false
  }"
  [parentModuleName]="'FINANCE_MANAGEMENT'"
  [moduleName]="'SHIPPING_ADDRESS_LIST'"
  [gridName]="'grdShippingAddressList'"
>
</kl-grid>
